<!-- app-content-header start -->
<div class="">
  <app-alert id="default-alert"></app-alert>
</div>
<ng-container *ngIf="contentHeader">
  <div style="height: 4em;" class="content-header row mb-sm-3 mb-lg-0">
    <div class="content-header-left ps-0 ms-0">
      <div class="row ps-0 breadcrumbs-top">
        <div class="d-flex">
          <h2 class="content-header-title float-start mb-0">
            {{ contentHeader.headerTitle }}
          </h2>
          <!-- app-breadcrumb component -->
          <app-breadcrumb [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- app-content-header end -->
